// @flow

import { h800 } from '@atlaskit/theme/typography';
import { H1, Link } from '@atlassian/amkt-common';
import styled from '@emotion/styled';

export const ErrorPage = styled<{ padding: string }>('div')`
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: ${props => props.padding};
`;

export const ErrorPageInner = styled.div`
  margin: auto;
  max-width: 500px;
`;

export const ErrorPageImage = styled.img`
  display: flex;
  flex-direction: column;
  margin: auto;
  width: 250px;
  height: 210px;
`;
export const Text = styled.div`
  margin-top: 40px;
  text-align: center;
`;

export const Heading = styled(H1)`
  ${h800()};
`;

export const MoreInfo = styled.div`
  line-height: 24px;
`;

export const GoBackLink = styled(Link)`
  cursor: pointer;
`;
